import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfitLoss } from '../../redux/slice/profitLoss/profitLossSlice';
import Loader from "components/loader";
import { useLocation } from "react-router-dom";


const ProfitLoss = () => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { data, loading, error } = useSelector((state) => state.profitLoss);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [eventType, setEventType] = useState(4);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'day'));
    const [toDate, setToDate] = useState(dayjs());

    const [filteredData, setFilteredData] = useState();

    // const paginatedData = data && data?.data.slice(startIndex, endIndex);
    const paginatedData = filteredData?.slice(startIndex, endIndex);
    let locale = {
        emptyText: 'No data!',
    };

    useEffect(() => {
        if (data) {
            setFilteredData(data?.data)
        }
    }, [data])


    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };
    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'index',
            render: (_, record, index) => (
                <span>{(index + 1)}</span>
            )
        },
        {
            title: 'Date',
            dataIndex: 'updated_at',
            render: (_, record) => (
                <span>{new Date(record?.updated_at).toLocaleString()}</span>
            ),
        },
        {
            title: 'Event Name',
            dataIndex: 'event_name',
            width: '30%',
            render: (_, record) => (
                <span className=''>{record?.event_name}</span>
            )
        },
        // {
        //     title: 'Market',
        //     dataIndex: 'market',
        //     render: (_, record) => (
        //         <span className=''>Match Odds</span>
        //     )
        // },
        {
            title: 'PL',
            dataIndex: 'pl',
            align: 'right',
            render: (_, record) => (
                record.total_p_l < 0 ? (
                    <span className='font-extrabold text-[#ff0000] text-[0.813rem] '>
                        {record?.total_p_l?.toFixed(2)}
                    </span>
                ) : (
                    <span className='font-extrabold text-[#008000] text-[0.813rem] '>{
                        record?.total_p_l?.toFixed(2)
                    }</span>
                )
            )
        },

    ];
    const handleSearch = (value, dataIndex) => {

        if (!value) {
            setFilteredData(data?.data)
            return;
        }

        const filtered = data?.data.filter(item => {
            return Array.isArray(dataIndex)
                ? dataIndex.some(key => item[key]?.toString().toLowerCase().includes(value.toLowerCase()))
                : item[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
        });

        // const filtered = data.length ? data.filter(item => item[dataIndex].toString().toLowerCase().includes(value.toLowerCase())) : [];
        setFilteredData(filtered);
        setCurrent(1); // Reset to the first page after a search
    };

    useEffect(() => {
        const params = {
            event_type: eventType,
            user_id: state?.id || profileData?._id,
            from_date: fromDate.format("YYYY-MM-DD"),
            to_date: toDate.format("YYYY-MM-DD"),
        };
        dispatch(fetchProfitLoss(params));
    }, [dispatch, profileData])
    const handleGoClick = () => {
        const params = {
            event_type: eventType,
            user_id: state?.id || profileData?._id,
            from_date: fromDate.format("YYYY-MM-DD"),
            to_date: toDate.format("YYYY-MM-DD"),
        };
        dispatch(fetchProfitLoss(params));
    };

    const handleResetClick = () => {
        setEventType(4);
        setFromDate(dayjs().subtract(1, 'day'));
        setToDate(dayjs());
    };

    console.log('data:', data?.data)

    return (
        <>
            {loading && <Loader />}
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                    <div className='col-span-12'>
                        <div className='relative w-full'>
                            <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Profit & Loss Report</p>
                        </div>
                        <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                            <div className="grid grid-cols-12">
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div className="text-[15px] relative mb-4">
                                        <select title="event" className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal [transition:border-color_.15sease-in-out,_box-shadow_.15sease-in-out] w-full [word-wrap:normal]" name="event" value={eventType} onChange={(e) => setEventType(e.target.value)} >
                                            <option value={4}>Cricket</option>
                                            <option value={1}>Soccer</option>
                                            <option value={2}>Tennis</option>
                                            {/* <option value={}>Fancy</option> */}
                                            {/* <option value="Live Casino">Live Casino</option> */}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div className="text-[15px] relative mb-4">
                                        <DatePicker
                                            inputReadOnly
                                            className="!w-full"
                                            onChange={(date) => setFromDate(date)}
                                            allowClear={false}
                                            value={fromDate}
                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div className="text-[15px] relative mb-4">
                                        <DatePicker
                                            inputReadOnly
                                            className="!w-full"
                                            onChange={(date) => setToDate(date)}
                                            value={toDate}
                                            allowClear={false}

                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mb-4 !mt-[.5rem] relative w-full !px-[6px] !py-[0]">
                                    <div className="inline-flex relative align-middle" role="group" aria-label="Basic example" id="divpagecount">
                                        <button className="rounded-br-none rounded-tr-none flex-auto relative cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal [transition:color_.15sease-in-out,_background-color_.15sease-in-out,_border-color_.15sease-in-out,_box-shadow_.15sease-in-out]" disabled={loading} onClick={handleGoClick}>Go</button>
                                        <button className="rounded-bl-none rounded-tl-none flex-auto relative cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal [transition:color_.15sease-in-out,_background-color_.15sease-in-out,_border-color_.15sease-in-out,_box-shadow_.15sease-in-out] ml-[.25rem]" onClick={handleResetClick}>Reset</button>
                                    </div>
                                </div>
                            </div>

                            <div className='col-span-12'>
                                <Table
                                    title={() => (
                                        <div className='grid grid-cols-12 my-[.5rem]'>
                                            <div className='col-span-12 lg:col-span-6 flex items-center mt-[.25rem] justify-start '>
                                                <div className=' flex float-left'>
                                                    <div className="text-[15px] relative flex gap-2 w-[200px]">
                                                        Search:
                                                        <Input
                                                            onChange={e => handleSearch(e.target.value, ['event_name', 'total_p_l'])}
                                                            className="!text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding !bg-[#fff] border-[1px] border-[solid] !border-[#ced4da] rounded-[.25rem] !text-[#495057] block font-normal leading-normal [transition:border-color_.15sease-in-out,_box-shadow_.15sease-in-out] w-full"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-span-12 lg:col-span-6 flex items-center justify-end  '>
                                                <div className='  p-[.5rem] lg:p-[0px]'>
                                                    <span class="text-[#000] float-right text-[14px] mr-[5px] mt-[4px] !ml-[.5rem] !inline2">entries</span>
                                                    <div className="text-[15px] relative float-right">
                                                        <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px] '>
                                                            <Select.Option value={10}>10</Select.Option>
                                                            <Select.Option value={25}>25</Select.Option>
                                                            <Select.Option value={50}>50</Select.Option>
                                                            <Select.Option value={100}>100</Select.Option>
                                                        </Select>
                                                    </div>
                                                    <span class="text-[#000] float-right text-[14px] mr-[5px] mt-[4px] !inline">Show</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    locale={locale}
                                    columns={columns}
                                    className='px-[.5rem] account-statement'
                                    bordered
                                    dataSource={paginatedData}
                                    pagination={false}
                                // summary={(pageData) => {
                                //     const totalAmount = pageData.reduce((sum, record) => sum + (record.totalPL + (record.commissionAmount || 0)), 0);
                                //     return (
                                //         <Table.Summary.Row>
                                //             <Table.Summary.Cell colSpan={3} className="font-bold">
                                //                 Total
                                //             </Table.Summary.Cell>
                                //             <Table.Summary.Cell align="right" className="font-bold">
                                //                 <span className=' text-[#508d0e]  '>{totalAmount.toFixed(2)}</span>
                                //             </Table.Summary.Cell>
                                //         </Table.Summary.Row>
                                //     );
                                // }}
                                />
                                <div className='grid grid-cols-12 items-center py-[1rem] px-[.5rem]'>
                                    <div className='col-span-12 lg:col-span-6  '>
                                        Showing {startIndex + 1} - {endIndex} of {filteredData && filteredData.length} entries
                                    </div>
                                    <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                        <Pagination
                                            current={current}
                                            pageSize={pageSize}
                                            total={filteredData && filteredData.length}
                                            onChange={(page) => setCurrent(page)}
                                            itemRender={(page, type, originalElement) => {
                                                if (type === 'prev') {
                                                    return <button type='button' className='!cursor-pointer'>Prev</button>;
                                                }
                                                if (type === 'page') {
                                                    return null;
                                                }
                                                if (type === 'next') {
                                                    return <button type='button' className='!cursor-pointer'>Next</button>;
                                                }
                                                return originalElement;
                                            }}
                                            showSizeChanger={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                </div >
            </div >
        </>
    )
}
export default ProfitLoss